/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterConversationTopicKind =
  (typeof FilterConversationTopicKind)[keyof typeof FilterConversationTopicKind];

export const FilterConversationTopicKind = {
  conversation_topic: 'conversation_topic',
} as const;
